import { NumberChartModel } from '../models/chart/number-chart.model';
import { ChartStylingModel } from '../models/chart/chart-styling.model';

export const /** @type {?} */ NumberChartTemplates = {
  defaultTemplate: {
    property: new NumberChartModel({
      display: true,
      disable: false,
      autoScale: true,
      gradient: false,
      showLegend: true,
      legendPosition: 'right',
      chartAlignment: 'start',
      colorSchemeName: 'forest',
      colorScheme: {
        domain: []
      },
      showXAxis: true,
      showYAxis: true,
      showXAxisLabel: true,
      showYAxisLabel: true,
      xAxisLabel: '',
      yAxisLabel: '',
      backgroundColor: '#009688',
      emptyBackgroundColor: '#6e9588',
      textColor: 'white'
    }),
    style: new ChartStylingModel({
      barsContainerWidth: '100%',
      barsContainerHeight: '200px'
    })
  }
}
